"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.combine = void 0;
const combine = (...params) => {
  return `${params.join('/')}`.replace(/\/{2,}/g, '/').replace(':/', '://');
};
exports.combine = combine;